"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _stencilReactDesc = require("@amzn/stencil-react-desc");

var _context = require("../context");

var _utils = require("../utils");

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  margin: 0;\n  padding: 0;\n  border: none;\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var getSize = function getSize(size) {
  return size === 'wide' ? 2 : 1;
};

var HrBase = (0, _context.styledWithTheme)('hr', {
  shouldForwardProp: (0, _utils.filterProps)(['color', 'size'])
})(_templateObject(), function (_ref) {
  var theme = _ref.theme,
      color = _ref.color,
      size = _ref.size;
  return "\n    border-top: ".concat(getSize(size), "px solid ").concat(theme.selectors.colorOrNull(color) || color, ";\n  ");
});
HrBase.defaultProps = {
  color: 'accent5',
  size: 'narrow'
};
var HrBaseWithDocs = (0, _stencilReactDesc.describe)(HrBase).description('Horizontal line to separate content on the page.');
HrBaseWithDocs.propTypes = {
  color: _stencilReactDesc.PropTypes.string.description('Color of the horizontal rule. Supports any named color from the Theme'),
  size: _stencilReactDesc.PropTypes.oneOf(['narrow', 'wide']).description('Size of the horizontal rule, either narrow or wide.')
};
var Hr = (0, _utils.withTestAttributes)({
  component: 'StencilReactHr'
})(HrBaseWithDocs);
Hr.displayName = 'Hr';
var _default = Hr;
exports.default = _default;